import { ARTICLE_MODEL_KEY_POINTER } from 'models/daos/article/constants'

const ARTICLES_DOMAIN = 'articles'
const ARTICLES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const ARTICLES_DOMAIN_MAP_KEY = ARTICLE_MODEL_KEY_POINTER

const ARTICLE_MARKDOWN_REGEX = {
  IMG: /!\[.*\]\(.*\)/g,
  OBJECT: /({.+})/g,
  TITLE_ID_ANCHOR: /(<.+ )id="(.+)">(.+)(<\/.+>)/gm
}

export {
  ARTICLES_DOMAIN,
  ARTICLES_DOMAIN_MAP_KEY,
  ARTICLES_STATE,
  ARTICLE_MARKDOWN_REGEX
}
